<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 143.322 63.367">
    <g id="Electric" transform="translate(10739.468 -558.177)">
      <path id="Path_87111" data-name="Path 87111"
        d="M45.814,553.061a2.471,2.471,0,0,0-2.465-2.465H36.663l2.111-15.376a2.467,2.467,0,0,0-4.5-1.691L17.591,558.793a2.465,2.465,0,0,0,2.057,3.825h6.484l-3.1,14.881a2.534,2.534,0,0,0-.051.508,2.462,2.462,0,0,0,4.462,1.434l17.909-24.947a2.467,2.467,0,0,0,.463-1.434M24.944,579.181l3.885-18.751H19.142l17.615-26.678-2.608,19.04h9.743Z"
        transform="translate(-10707.622 39.149)" :fill="themeColor" />
      <path id="Path_87112" data-name="Path 87112" d="M20.077,549.744Z" transform="translate(-10702.255 71.3)"
        :fill="themeColor" />
      <path id="Path_87113" data-name="Path 87113" d="M20.077,549.744Z" transform="translate(-10702.255 71.3)"
        fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="1" />
      <path id="Path_87114" data-name="Path 87114"
        d="M57.476,543.38a11.614,11.614,0,0,0-8.258-3.419h-.006a11.678,11.678,0,1,0,0,23.356h.006a11.68,11.68,0,0,0,8.255-19.937M56,558.421a9.525,9.525,0,0,1-6.787,2.811h-.006a9.6,9.6,0,0,1-9.594-9.591,9.628,9.628,0,0,1,9.591-9.6h.011A9.6,9.6,0,0,1,56,558.421"
        transform="translate(-10669.841 53.14)" :fill="themeColor" />
      <path id="Path_87115" data-name="Path 87115"
        d="M18.075,539.961A11.679,11.679,0,1,0,29.755,551.64a11.693,11.693,0,0,0-11.679-11.679m6.781,18.466a9.524,9.524,0,0,1-6.781,2.808H18.07a9.6,9.6,0,1,1,6.787-2.808"
        transform="translate(-10727.646 53.14)" :fill="themeColor" />
      <path id="Path_87116" data-name="Path 87116"
        d="M143.044,570.887a1.031,1.031,0,0,0,.277-.92c-2.108-11.088-4.6-18.577-6.675-20.034-2.656-1.868-9.32-2.339-18.446-2.8a58.293,58.293,0,0,1-13.145-1.4l-.46-.186a39.362,39.362,0,0,1-7.6-6.261c-4.21-3.976-9.049-8.549-13.516-9.763-11.319-3.062-65.48-1.362-70.4-.84l-.351.032-6.207.551a1.037,1.037,0,0,0-.925,1.131,1.048,1.048,0,0,0,.794.914l.328.023,2.628-.234-1.071,2.313c-.08.151-.16.3-.24.457v.328l-.163,0c-2.428,4.916-4.13,11.825-5.147,16.884l-.2.5L.184,555.151a1.039,1.039,0,0,0-.166.566c0,7.489.668,20.04,5.141,20.04h6.284a1.038,1.038,0,1,0,0-2.077H4.862l-.426-.643c-1.317-2-2.282-8.817-2.342-16.581l0-.428,2.422-3.722a1.061,1.061,0,0,0,.146-.36c1.494-7.455,5.053-19.78,8.24-21.1l.834-.149c5.893-.5,58.514-2.068,69.2.811,3.95,1.065,8.592,5.456,12.685,9.329a36.271,36.271,0,0,0,8.3,6.67A50.742,50.742,0,0,0,118,549.2c8.583.428,15.235.874,17.449,2.431,2.536,2.411,5.55,17.3,5.581,17.452l.149.74-4.087,4.182a1.007,1.007,0,0,0-.257.719,1.039,1.039,0,0,0,1.765.709Z"
        transform="translate(-10739.485 30.443)" :fill="themeColor" />
      <path id="Path_87117" data-name="Path 87117"
        d="M28.747,545.9H48.8a1.04,1.04,0,1,0,0-2.079H28.747a1.04,1.04,0,0,0,0,2.079"
        transform="translate(-10688.086 60.301)" :fill="themeColor" />
    </g>
  </svg>


</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
